<template>
  <div class="ai-fabric-root">
    <transition name="ai-fabric-slide">
      <div
        v-if="visible && minimized"
        class="ai-fabric-minimized cursor"
        @click="minimized = false"
      >
        <Icon type="md-color-wand" size="18" color="#fff" />
        <span>AI 找面料</span>
      </div>
    </transition>
    <transition name="ai-fabric-slide">
      <div v-if="visible && !minimized" class="ai-fabric-panel">
      <div class="ai-header">
        <div class="ai-title-box">
          <Icon type="md-color-wand" size="18" color="#fff" />
          <span class="ai-title">AI 找面料</span>
        </div>
        <div class="ai-header-right">
          <span :class="['ai-status', loggedIn ? 'ready' : '']">
            {{ loggingIn ? '登录中...' : (loggedIn ? '已就绪' : '未登录') }}
          </span>
          <Icon type="md-remove" size="20" color="#fff" class="ai-min" @click="minimize" />
          <Icon type="md-close" size="22" color="#fff" class="ai-close" @click="close" />
        </div>
      </div>

      <div class="ai-body" ref="body">
        <div v-if="messages.length === 0" class="ai-welcome">
          <div class="welcome-title">你好，我是 AI 找面料助手</div>
          <div class="welcome-desc">用自然语言描述你需要的面料，我会从面料库中为你筛选，例如：</div>
          <div
            class="suggestion-item"
            v-for="(s, i) in suggestions"
            :key="i"
            @click="quickSend(s)"
          >
            {{ s }}
          </div>
          <div v-if="!loggedIn && !loggingIn" class="retry-login" @click="login">
            登录失败，点击重新登录
          </div>
        </div>

        <div class="msg-list">
          <div v-for="(m, idx) in messages" :key="idx" :class="['msg-item', m.role]">
            <div class="bubble">{{ m.content }}</div>

            <div
              v-if="m.clarification && m.clarification.options && m.clarification.options.length"
              class="clarify-options"
            >
              <div
                class="option-chip"
                v-for="(opt, oi) in m.clarification.options"
                :key="oi"
                @click="quickSend(opt)"
              >
                {{ opt }}
              </div>
            </div>

            <div v-if="m.isError" class="retry-login" @click="login">重新登录</div>

            <div v-if="m.results && m.results.length" class="result-list">
              <div class="result-tip">
                已为你筛选出 {{ m.results.length }} 条面料，并同步到左侧列表
              </div>
              <div class="result-card" v-for="(r, ri) in m.results" :key="ri">
                <div class="result-img-box">
                  <img
                    v-if="r.images && r.images.length && r.images[0].url"
                    :src="r.images[0].url"
                    class="result-img"
                    @error="onImgError"
                  />
                </div>
                <div class="result-info">
                  <div class="result-name">{{ r.name }}</div>
                  <div class="result-row">编号：{{ r.fabric_key || '-' }}</div>
                  <div class="result-row">
                    成分：{{ r.composition || '-' }}
                  </div>
                  <div class="result-row">
                    克重：{{ r.weight || '-' }}
                    <span class="result-divider">|</span>
                    幅宽：{{ r.width || '-' }}
                  </div>
                  <div class="result-row" v-if="r.classification">
                    分类：{{ r.classification }}
                  </div>
                  <div class="result-tags" v-if="(r.tags && r.tags.length) || r.match_score != null">
                    <span class="tag score" v-if="r.match_score != null">匹配度 {{ r.match_score }}</span>
                    <span class="tag" v-for="(t, ti) in r.tags" :key="ti">{{ t }}</span>
                  </div>
                  <div class="result-reasons" v-if="r.reasons && r.reasons.length">
                    <div v-for="(rs, rsi) in r.reasons" :key="rsi">· {{ rs }}</div>
                  </div>
                  <div class="result-warnings" v-if="r.warnings && r.warnings.length">
                    <div v-for="(w, wi) in r.warnings" :key="wi">{{ w }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="loading" class="msg-item assistant">
            <div class="bubble typing">
              <span></span><span></span><span></span>
            </div>
          </div>
        </div>
      </div>

      <div class="ai-footer">
        <textarea
          v-model="input"
          class="ai-input"
          rows="2"
          placeholder="描述你需要的面料，回车发送（Shift+回车换行）"
          @keydown.enter.exact.prevent="send"
          :disabled="!loggedIn || loading"
        ></textarea>
        <button
          class="send-btn"
          @click="send"
          :disabled="!loggedIn || loading || !input.trim()"
        >
          发送
        </button>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import $store from "@/store";

// AI找面料服务由本站后端代理转发（外部服务未开放浏览器跨域）
// 后端代理目标：https://deadmin.yichuanghub.com/fabric
const BASE_URL = process.uniEnv.BASE_API;
const ACCOUNT = "admin";
const PASSWORD = "adminqwe123";
// 会话相关浏览器存储key（每次打开弹窗清空会话，token随登录更新）
const TOKEN_KEY = "ai_fabric_token";
const CONVERSATION_KEY = "ai_fabric_conversation_id";
const VERSION_KEY = "ai_fabric_version_id";

// 本站登录态（代理接口与其他业务接口一样需要登录）
function authHeaders(extra) {
  return Object.assign(
    {
      "Content-Type": "application/json",
      Authorization: "Bearer " + ($store.state.token || ""),
    },
    extra || {}
  );
}

export default {
  name: "AiFabricSearch",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      token: "",
      loggedIn: false,
      loggingIn: false,
      input: "",
      loading: false,
      messages: [],
      minimized: false,
      suggestions: [
        "找适合衬衫的鲜艳浅蓝色全棉面料，150GSM以内",
        "适合做连衣裙的浅色雪纺面料，轻薄透气",
        "100%棉、200克左右、适合做卫衣的面料",
      ],
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.initChat();
      }
    },
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    minimize() {
      this.minimized = true;
    },
    onImgError(e) {
      e.target.style.visibility = "hidden";
    },
    // 每次打开：清空会话存储 + 重新登录
    initChat() {
      this.messages = [];
      this.input = "";
      this.loading = false;
      this.minimized = false;
      localStorage.removeItem(CONVERSATION_KEY);
      localStorage.removeItem(VERSION_KEY);
      this.login();
    },
    async login() {
      this.loggingIn = true;
      this.loggedIn = false;
      try {
        const res = await axios.post(
          BASE_URL + "/fabric/ai-login",
          { account: ACCOUNT, password: PASSWORD },
          {
            headers: authHeaders(),
            timeout: 30000,
          }
        );
        if (res.data && res.data.token) {
          this.token = res.data.token;
          localStorage.setItem(TOKEN_KEY, this.token);
          this.loggedIn = true;
        } else {
          this.onLoginFail();
        }
      } catch (e) {
        console.error("[AiFabricSearch] login error:", e);
        this.onLoginFail();
      } finally {
        this.loggingIn = false;
      }
    },
    onLoginFail() {
      this.loggedIn = false;
      if (this.$layer) {
        this.$layer.msg("AI找面料登录失败，请稍后重试");
      }
    },
    saveSession(data) {
      if (data.conversation_id) {
        localStorage.setItem(CONVERSATION_KEY, data.conversation_id);
      }
      if (data.version != null) {
        localStorage.setItem(VERSION_KEY, String(data.version));
      }
    },
    clearSession() {
      localStorage.removeItem(CONVERSATION_KEY);
      localStorage.removeItem(VERSION_KEY);
    },
    quickSend(text) {
      if (this.loading || !this.loggedIn) return;
      this.input = text;
      this.send();
    },
    async send() {
      const message = (this.input || "").trim();
      if (!message || this.loading || !this.loggedIn) return;
      this.messages.push({ role: "user", content: message });
      this.input = "";
      this.loading = true;
      this.$nextTick(this.scrollToBottom);
      try {
        const data = await this.queryAgent(message);
        this.handleQueryData(data);
      } catch (e) {
        this.messages.push({
          role: "assistant",
          content: e.message || "查询失败，请稍后重试",
          results: [],
        });
      } finally {
        this.loading = false;
        this.$nextTick(this.scrollToBottom);
      }
    },
    async queryAgent(message) {
      const body = {
        message,
        ai_token: this.token,
      };
      const conversationId = localStorage.getItem(CONVERSATION_KEY);
      const version = localStorage.getItem(VERSION_KEY);
      if (conversationId && version) {
        body.conversation_id = conversationId;
        body.version = Number(version);
      }
      try {
        const res = await axios.post(
          BASE_URL + "/fabric/ai-query",
          body,
          {
            headers: authHeaders(),
            timeout: 60000,
          }
        );
        if (res.data && res.data.ok) {
          return res.data.data;
        }
        const errMsg = res.data && res.data.error && res.data.error.message;
        throw new Error(errMsg || "查询失败，请稍后重试");
      } catch (e) {
        if (e.response) {
          const status = e.response.status;
          const errData = e.response.data && e.response.data.error;
          if (errData && errData.code === "CONVERSATION_NOT_FOUND") {
            this.clearSession();
            throw new Error("会话已失效，请重新描述你的找料需求");
          }
          if (errData && errData.code === "CONVERSATION_CONFLICT") {
            this.clearSession();
            throw new Error("会话已在其他页面更新，请重新描述你的找料需求");
          }
          if (status === 401) {
            throw new Error("登录已失效，请重新打开弹窗");
          }
          throw new Error((errData && errData.message) || "查询失败，请稍后重试");
        }
        throw new Error(e.message || "网络异常，请稍后重试");
      }
    },
    handleQueryData(data) {
      this.saveSession(data);
      const stage = data.stage;
      const assistantMsg = {
        role: "assistant",
        content:
          data.assistant_message ||
          (stage === "no_result" ? "没有找到符合条件的面料，请调整条件后再试。" : ""),
        clarification: stage === "clarify" ? data.clarification : null,
        results: Array.isArray(data.results) ? data.results : [],
      };
      this.messages.push(assistantMsg);

      // stage为results时将面料编号同步给外部列表
      if (stage === "results") {
        const keys = assistantMsg.results
          .map((r) => r.fabric_key)
          .filter((k) => !!k);
        this.$emit("apply", keys);
      }
    },
    scrollToBottom() {
      const el = this.$refs.body;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-fabric-root {
  // 根节点仅作包裹，无视觉表现（子元素均为fixed定位）
}
.ai-fabric-minimized {
  position: fixed;
  left: 12px;
  bottom: 24px;
  height: 44px;
  padding: 0 18px;
  background: linear-gradient(135deg, #5b8ff9, #3d6fe0);
  border-radius: 22px;
  display: flex;
  align-items: center;
  column-gap: 8px;
  color: #fff;
  font-size: 14px;
  box-shadow: 0 4px 16px rgba(61, 111, 224, 0.4);
  z-index: 900;
  user-select: none;
  &:hover {
    box-shadow: 0 6px 20px rgba(61, 111, 224, 0.55);
  }
}
.ai-fabric-panel {
  position: fixed;
  top: 12px;
  left: 12px;
  width: 480px;
  max-width: 50vw;
  height: calc(100vh - 24px);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
  z-index: 900;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.ai-fabric-slide-enter-active,
.ai-fabric-slide-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.ai-fabric-slide-enter,
.ai-fabric-slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
.ai-header {
  flex: 0 0 52px;
  background: linear-gradient(135deg, #5b8ff9, #3d6fe0);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px 0 18px;
}
.ai-title-box {
  display: flex;
  align-items: center;
  column-gap: 8px;
}
.ai-title {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}
.ai-header-right {
  display: flex;
  align-items: center;
  column-gap: 12px;
}
.ai-status {
  color: rgba(255, 255, 255, 0.75);
  font-size: 12px;
}
.ai-status.ready {
  color: #d8ffd6;
}
.ai-close {
  cursor: pointer;
}
.ai-min {
  cursor: pointer;
}
.ai-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: #f7f8fa;
}
.ai-welcome {
  margin-bottom: 8px;
}
.welcome-title {
  font-size: 15px;
  font-weight: bold;
  color: #1a1a1a;
  margin-bottom: 8px;
}
.welcome-desc {
  font-size: 13px;
  color: #666;
  margin-bottom: 12px;
}
.suggestion-item {
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  color: #333;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s;
  line-height: 1.5;
}
.suggestion-item:hover {
  border-color: #5b8ff9;
  color: #3d6fe0;
}
.msg-item {
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
}
.msg-item.user {
  align-items: flex-end;
}
.msg-item.assistant {
  align-items: flex-start;
}
.bubble {
  max-width: 88%;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.6;
  word-break: break-word;
  white-space: pre-wrap;
}
.msg-item.user .bubble {
  background: #5b8ff9;
  color: #fff;
  border-bottom-right-radius: 2px;
}
.msg-item.assistant .bubble {
  background: #fff;
  color: #333;
  border: 1px solid #ebeef5;
  border-bottom-left-radius: 2px;
}
.clarify-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  max-width: 92%;
}
.option-chip {
  background: #eef4ff;
  border: 1px solid #b9d0ff;
  color: #3d6fe0;
  border-radius: 14px;
  padding: 5px 14px;
  font-size: 12px;
  cursor: pointer;
}
.option-chip:hover {
  background: #5b8ff9;
  color: #fff;
}
.result-list {
  width: 94%;
  margin-top: 8px;
}
.result-tip {
  font-size: 12px;
  color: #3d6fe0;
  margin-bottom: 8px;
}
.result-card {
  display: flex;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 8px;
  column-gap: 10px;
}
.result-img-box {
  flex: 0 0 72px;
  width: 72px;
  height: 72px;
  border-radius: 6px;
  overflow: hidden;
  background: #f2f2f2;
}
.result-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.result-info {
  flex: 1;
  min-width: 0;
}
.result-name {
  font-size: 13px;
  font-weight: bold;
  color: #1a1a1a;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.result-row {
  font-size: 12px;
  color: #666;
  line-height: 1.7;
}
.result-divider {
  margin: 0 6px;
  color: #ddd;
}
.result-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}
.tag {
  font-size: 11px;
  color: #666;
  background: #f2f3f5;
  border-radius: 4px;
  padding: 1px 6px;
}
.tag.score {
  color: #ff8c1a;
  background: #fff3e6;
}
.result-reasons {
  margin-top: 4px;
  font-size: 12px;
  color: #888;
  line-height: 1.6;
}
.result-warnings {
  margin-top: 4px;
  font-size: 12px;
  color: #f56c6c;
  line-height: 1.6;
}
.retry-login {
  margin-top: 8px;
  font-size: 12px;
  color: #3d6fe0;
  cursor: pointer;
}
.typing {
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
}
.typing span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #b0b3bb;
  animation: ai-typing 1.2s infinite ease-in-out;
}
.typing span:nth-child(2) {
  animation-delay: 0.2s;
}
.typing span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes ai-typing {
  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.4;
  }
  30% {
    transform: translateY(-4px);
    opacity: 1;
  }
}
.ai-footer {
  flex: 0 0 auto;
  border-top: 1px solid #ebeef5;
  padding: 10px 12px;
  display: flex;
  align-items: flex-end;
  column-gap: 10px;
  background: #fff;
}
.ai-input {
  flex: 1;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 13px;
  resize: none;
  outline: none;
  font-family: inherit;
  line-height: 1.5;
  max-height: 100px;
}
.ai-input:focus {
  border-color: #5b8ff9;
}
.ai-input:disabled {
  background: #f5f7fa;
  color: #bbb;
}
.send-btn {
  flex: 0 0 auto;
  border: none;
  background: #5b8ff9;
  color: #fff;
  border-radius: 8px;
  padding: 9px 18px;
  font-size: 13px;
  cursor: pointer;
}
.send-btn:disabled {
  background: #b3c8f5;
  cursor: not-allowed;
}
</style>
